import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Stack, Divider, Button } from "@mui/material";
import { onAuthChange, logOut } from "../firebase";

interface ProfileProps {
  userName: string | null;
  onSignOut: () => void;
}

export default function Profile({
  userName,
  onSignOut,
}: ProfileProps): JSX.Element {
  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    const unsub = onAuthChange((user) => {
      setEmail(user?.email ?? null);
    });
    return () => unsub();
  }, []);

  const displayName = userName || "User";

  const handleSignOut = () => {
    onSignOut();
  };

  return (
    <Box sx={{ maxWidth: 640, ml: 0, mt: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
        Profile
      </Typography>
      <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
        Manage your account details and session.
      </Typography>

      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Stack spacing={2}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography variant="overline" sx={{ color: "text.secondary" }}>
                Display name
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                {displayName}
              </Typography>
            </Box>
          </Stack>

          <Divider flexItem />

          <Box>
            <Typography variant="overline" sx={{ color: "text.secondary" }}>
              Email
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              {email || "Not available"}
            </Typography>
          </Box>

          <Divider flexItem />

          <Stack direction="row" spacing={2}>
            <Button variant="contained" color="primary" onClick={handleSignOut}>
              Sign out
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
